import React, {useEffect} from 'react';
import {Modal} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {installationSelectData, showDeleteModal} from "../../redux-store/selectors";
import {
    deleteDynamicTable,
    getDynamicTableList,
    initializeDeleteModal,
    setShowDeleteModal,
    unmountDeleteModal
} from "../../redux-store/dynamicTable";

function TableConfigConfirmDeleteModal({id}) {

    const dispatch = useDispatch()
    const show = useSelector(showDeleteModal).find(modal => modal.id === id)?.show || false
    const {selected} = useSelector(installationSelectData)


    useEffect(() => {
        dispatch(initializeDeleteModal(id))
        return () => {
            dispatch(unmountDeleteModal(id))
        }
    }, [])

    const handleDeleteItem = async () => {
        dispatch(deleteDynamicTable({tableId: id, installationId: selected.value}))
        dispatch(getDynamicTableList(selected.value))
    }

    return (
        <Modal
            show={show}
            onHide={() => {
                dispatch(setShowDeleteModal({show: false, id}))
            }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className={"modal-header-component text-center"}>
                <Modal.Title className={"title-confirm"}>Potvrda brisanja</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={"mb-5 text-left"}>
                    <h5>Da li ste sigurni da želite obrisati ovu tabelu?</h5>
                </div>
                <div className={"modal-footer-component text-right"}>
                    <button className={"btn btn-modal-cancel"} onClick={() => {
                        dispatch(setShowDeleteModal({show: false, id}))
                    }}>
                        Odustani
                    </button>
                    <button className={"btn btn-modal-confirm-delete"} onClick={handleDeleteItem}>Obriši</button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default TableConfigConfirmDeleteModal;